var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.myClass,attrs:{"type":"button"},on:{"click":_vm.clicked}},[(!_vm.loading)?_c('i',{staticClass:"fa-fw",class:_vm.myIcon}):_vm._e(),_vm._v(" "),(_vm.loading)?_c('i',{staticClass:"fa fa-fw fa-spinner fa-spin"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }